import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';

import './App.css';
import HomeScreen from './components/home/HomeScreen';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SignIn from './components/signin/SignIn';
import TranslationQuotePage from './components/quotes/TranslationQuoteScreen';
import TranslationsHomeScreen from './components/translations/TranslationsHomeScreen';
import TranslationsCreateScreen from './components/translations/create/TranslationsCreateScreen';
import TranslationsMyRequestsScreen from './components/translations/requests/TranslationsMyRequestsScreen';
import TranslationsMyRequestDetailScreen from './components/translations/details/TranslationsMyRequestDetailScreen';
import { ErrorBoundary } from './analytics/ErrorBoundary';

function App() {
  return (
    <Authenticator.Provider>
      <ErrorBoundary
        fallback={<></>}
        onError={(error, errorInfo) => {
          console.log("Error occurred and has been logged.")
        }}
      >
        <div className="App">
          <Router>
            <Routes>
              <Route path="/" element={<HomeScreen />} />
              <Route path="/signin" element={<SignIn />} />
              <Route path="/quotes" element={<TranslationQuotePage />} />
              <Route path="/translations" element={<TranslationsHomeScreen />} />
              <Route path="/translations/create" element={<TranslationsCreateScreen />} />
              <Route path="/translations/myrequests" element={<TranslationsMyRequestsScreen />} />
              <Route path="/translations/myrequests/details" element={<TranslationsMyRequestDetailScreen />} />
            </Routes>

          </Router>

        </div>
      </ErrorBoundary>

    </Authenticator.Provider>
  );
}

export default App;
